module.exports = __webpack_public_path__ + "media/images/sp/stores/umeda/umeda_sns_06-2d83cb22c55deb2e4e603300a9dd0753.jpg";